import { useQueryClient } from '@tanstack/react-query';
import { Button, Container } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useTranslation } from 'react-i18next';
import { PiMusicNotes, PiTextT } from 'react-icons/pi';
import { useParams } from 'react-router-dom';
import { useTrackTranscript } from 'services/tracks';
import { ITrackMutationForm } from 'services/tracks/types';

const TrackText = () => {
  const {
    values,
    status,
    setFieldValue,
    initialValues,
  }: IFormikContextType<ITrackMutationForm> =
    useFormikContext<ITrackMutationForm>();

  const query = useQueryClient();

  const { id } = useParams();

  const generateTranscription = useTrackTranscript(id ?? '');

  const onGenerateTranscription = async () => {
    await generateTranscription.mutateAsync(undefined, {
      onSuccess: text => query.invalidateQueries({ queryKey: ['track'] }),
    });
  };

  const { t } = useTranslation();
  return (
    <Container className='max-w-[700px] self-start'>
      <Container.Header
        style={{
          borderBottomLeftRadius: values.isInstrumental ? '8px' : '',
          borderBottomRightRadius: values.isInstrumental ? '8px' : '',
        }}
        title={
          <>
            {values.isInstrumental ? <PiMusicNotes /> : <PiTextT />}
            {values.isInstrumental
              ? t('input.label.instrumental')
              : t('input.label.text')}
          </>
        }>
        {!initialValues.text?.trim() &&
          !initialValues.isInstrumental &&
          status?.displayMode && (
            <div className='p-4'>
              <Button
                size='compact'
                onClick={onGenerateTranscription}
                isLoading={generateTranscription.isPending}>
                <Button.Text text={t('button.generate-transcription')} />
              </Button>
            </div>
          )}
      </Container.Header>

      {status?.displayMode ? null : (
        <Container.Content>
          <FormInput.Checkbox
            name='isInstrumental'
            label={t('input.label.instrumental')}
            onChange={() => setFieldValue('text', '')}
          />
        </Container.Content>
      )}
      {status?.displayMode ? (
        <Container.Content
          style={{
            display: values.isInstrumental ? 'none' : '',
          }}>
          {values.text}
        </Container.Content>
      ) : values.isInstrumental ? null : (
        <Container.Content>
          <FormInput.Field
            className='h-[300px]'
            name='text'
            label={t('input.label.text')}
            disabled={values.isInstrumental}
          />
        </Container.Content>
      )}
    </Container>
  );
};

export default TrackText;
